<script setup>
const props = defineProps({
    width: {
        type: Number,
        default: 60,
    },
});
</script>

<template>
    <div>
        <div class="position-absolute top-50 start-50 translate-middle bg-white bg-opacity-50 w-100 h-100 d-flex justify-content-center align-items-center"
            style="z-index:100;">
            <!-- <video autoplay loop muted playsinline>
                <source src="/img/savicki-loader.webm" type="video/webm" />
            </video> -->
            <img src="/img/diamond-gem-small.webp" :alt="$t('alt.spinner')" :title="$t('alt.spinner')"
                :width="props.width">
        </div>
    </div>
</template>
